import { Directive, inject, input } from '@angular/core';
import { IDropTarget } from '@features/drag-and-drop/drag-and-drop.types';
import { DraggableDirective } from '@features/drag-and-drop/draggable.directive';
import { Wk8AudioService } from '@features/wk8/core/wk8-audio/wk8-audio.service';
import { Vector2Screen } from '@typings/vectors';

@Directive({
  selector: '[lpDraggable]',
})
export class LpDraggableDirective<T> extends DraggableDirective<T> {
  readonly #wk8AudioService = inject(Wk8AudioService);
  readonly alwaysShadow = input(false);

  ngAfterViewInit(): void {
    this.setGrabStyle(false);
  }

  public override entered(target: IDropTarget): void {
    super.entered(target);
    this.#wk8AudioService.playDraggableSnap();
    this.setGrabStyle(false);
  }

  public override exited(): void {
    // this.#wk8AudioService.playDraggableSnap();
    this.setGrabStyle(true);
  }

  protected override grab(position: Vector2Screen): void {
    super.grab(position);
    // this.#wk8AudioService.playDraggableGrab();

    this.setGrabStyle(true);
  }

  protected override drop(target: IDropTarget): void {
    super.drop(target);
    // this.#wk8AudioService.playDraggableDrop();
    this.setGrabStyle(false);
  }

  protected override release(position: Vector2Screen): void {
    super.release(position);
    // this.#wk8AudioService.playDraggableDrop();
    this.setGrabStyle(false);
  }

  private setGrabStyle(enabled: boolean) {
    const rotate = enabled ? `${Math.random() < 0.5 ? -5 : 5}deg` : '0deg';
    const filter = enabled || this.alwaysShadow() ? 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.5))' : 'none';
    const scale = enabled ? '1.1' : '1';
    if (this.dragMode() === 'AUTO') {
      this.el.nativeElement.style.rotate = rotate;
      this.el.nativeElement.style.filter = filter;
      this.el.nativeElement.style.scale = scale;
    }
    this.draggableChangedStyle.emit({ rotate, filter, scale });
  }
}
